import PropTypes from 'prop-types';
import { iconsList } from '../../icon/glyphs';
import { TYPES } from '../../icon/constants';

export const TreeViewActionType = PropTypes.shape({
  label: PropTypes.string,
  glyph: PropTypes.oneOf(iconsList),
  onClick: PropTypes.func,
});

const TreeViewListItemState = PropTypes.shape({
  isCollapsed: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isSelected: PropTypes.bool,
});

const TreeViewListItem = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  order: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(TreeViewActionType),
  iconGlyph: PropTypes.oneOf(iconsList).isRequired,
  iconType: PropTypes.oneOf(Object.values(TYPES)),
  isCollapsible: PropTypes.bool,
  isSelectable: PropTypes.bool,
  allowChildren: PropTypes.bool,
  state: TreeViewListItemState,
};

TreeViewListItem.items = PropTypes.arrayOf(PropTypes.shape(TreeViewListItem)).isRequired;

export const TreeViewListItemType = PropTypes.shape(TreeViewListItem);

export const DnDOffset = PropTypes.shape({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
});
